import React from 'react';
import { Answer } from 'yandex-metrica-ab-react/dist/types';

const VARIOQUB_SSR_CONTAINER = 'varioqub-ssr';

export const createVarioqubSSRContainer = (value?: Answer) => {
  if (!value) {
    return null;
  }
  return React.createElement('script', {
    dangerouslySetInnerHTML: { __html: JSON.stringify(value) },
    id: VARIOQUB_SSR_CONTAINER,
    type: 'application/json',
  });
};

export const clientSideGetSSRVarioqubValue = (): Answer => {
  const runtimeConfigContainer = document.getElementById(VARIOQUB_SSR_CONTAINER);
  return JSON.parse(runtimeConfigContainer?.textContent || JSON.stringify({ ready: false, flags: {} }));
};
